export default __webpack_public_path__ + "static/media/icon-legal.6e6ae925.svg";